import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAppToast from "src/hooks/useAppToast";
import { fetchUserAccountDetailsAsync } from "src/redux/actions/accountActions";
import { googleLoginAsync, handleOauthForConnectPlatformAsync,validateUserSessionGetAsync } from "src/redux/actions/authActions";
import { fetchPlatformsAsync } from "src/redux/actions/platformActions";
import { setIsLoggedIn } from "src/redux/slices/authSlice";
import { useAppDispatch, withSkipGlobalApiError } from "src/redux/storeHooks";
import "./GoogleButton.css";
import {finalizeTikTokAfterAuth} from "src/utils/finalizeTikTokAfterAuth";
import {getWalmartPlatformIdFromPayload, getUserIdFromAuthPayload, redirectToWalmartMarketplaceAuthIfNeeded} from "src/utils/walmartMarketplaceHandoff";
import {resetImpersonationForFreshLogin} from "src/utils/impersonationTokens";

export const accessSessionTokenKeyName = "access_token";
export const refreshSessionTokenKeyName = "refresh_token";

declare global {
  interface Window {
    google: any;
  }
}

const GoogleLoginButton: React.FC = () => {
    const dispatch = useAppDispatch()
    const {successToast, warningToast, errorToast} = useAppToast();
    const navigate = useNavigate()
    const location = useLocation();
  const googleButtonRef = useRef<HTMLDivElement>(null);

  const resolvePostLoginPath = (user: any): string => {
    const accountType = user?.account_type
    const isAdminShell =
      accountType === 'SUPERADMIN' ||
      accountType === 'ADMIN_STAFF' ||
      user?.user_type === 'SUPERADMIN' ||
      user?.is_superuser === true

    if (isAdminShell) return '/dashboard'
    if (user?.is_subscribed && user?.isOnboardingProcessCompleted) return '/dashboard'
    return '/pricing'
  }

  useEffect(() => {
    const renderGoogleButton = () => {
      if (!window.google || !googleButtonRef.current) return false;

      googleButtonRef.current.innerHTML = "";

      const buttonTextType =
        location.pathname === "/auth/registration"
          ? "signup_with"
          : "signin_with";

      window.google.accounts.id.initialize({
        client_id:
        `${process.env.REACT_APP_GOOGLE_CLIENT_ID}`,
        callback: handleCredentialResponse,
        auto_select: true,
        cancel_on_tap_outside: false,
      });

      window.google.accounts.id.renderButton(googleButtonRef.current, {
        theme: "outline",
        size: "large",
        text: buttonTextType,
        shape: "rectangular",
        logo_alignment: "left",
        width: "100%",
      });

      // :white_check_mark: Center the actual button
      const innerBtn = googleButtonRef.current.querySelector(
        'div[role="button"]'
      ) as HTMLDivElement | null;
      if (innerBtn) {
        innerBtn.style.width = "100%";
        innerBtn.style.justifyContent = "center";
      }

      // :white_check_mark: Observe DOM and remove any empty divs
      const observer = new MutationObserver(() => {
        googleButtonRef.current
          ?.querySelectorAll("div")
          .forEach((div) => {
            if (div.innerHTML.trim() === "") div.remove();
          });
      });

      observer.observe(googleButtonRef.current, {
        childList: true,
        subtree: true,
      });

      return true;
    };

    // The Google script loads async/defer, so retry until it's available.
    let retryTimer: ReturnType<typeof setTimeout> | null = null;
    let retryCount = 0;
    const maxRetries = 10;
    const retryDelayMs = 300;

    const renderWithRetry = () => {
      const rendered = renderGoogleButton();
      if (rendered || retryCount >= maxRetries) return;
      retryCount += 1;
      retryTimer = setTimeout(renderWithRetry, retryDelayMs);
    };

    renderWithRetry();

    const onResize = () => renderGoogleButton();
    window.addEventListener("resize", onResize);

    const scriptEl = document.querySelector<HTMLScriptElement>(
      'script[src*=\"accounts.google.com/gsi/client\"]'
    );
    const onScriptLoad = () => renderGoogleButton();
    scriptEl?.addEventListener("load", onScriptLoad);

    return () => {
      window.removeEventListener("resize", onResize);
      scriptEl?.removeEventListener("load", onScriptLoad);
      if (retryTimer) {
        clearTimeout(retryTimer);
      }
    };
  }, [location.pathname]);

  const handleCredentialResponse = async (response: any) => {
    try {
             const source = location.pathname === "/auth/registration" ? "SIGNUP" : "LOGIN";
      const loginResponse = await dispatch(googleLoginAsync(withSkipGlobalApiError({token: response.credential, source })))
                const data = loginResponse?.payload
                if(data?.status_code === 200) {
                    successToast(data?.data?.message);
                    resetImpersonationForFreshLogin()
                    localStorage.setItem(accessSessionTokenKeyName, data?.data?.access);
                    localStorage.setItem(refreshSessionTokenKeyName, data?.data?.refresh);
                    dispatch(setIsLoggedIn({isLoggedIn: true}));
                    const userResponse = await dispatch(fetchUserAccountDetailsAsync())
                    const loggedInUser = userResponse?.payload
                    let walmartOauthUserId = getUserIdFromAuthPayload(data?.data) ?? getUserIdFromAuthPayload(loggedInUser)
                    const walmartPlatformResponse = await dispatch(fetchPlatformsAsync({search: 'WALMART'}))
                    const walmartPlatformId = getWalmartPlatformIdFromPayload(walmartPlatformResponse?.payload)
                    if (await redirectToWalmartMarketplaceAuthIfNeeded((params) =>
                      dispatch(handleOauthForConnectPlatformAsync(params)),
                      {user_id: walmartOauthUserId, platform_id: walmartPlatformId}
                    )) {
                      return;
                    }
                    await finalizeTikTokAfterAuth(dispatch);
                    navigate(resolvePostLoginPath(loggedInUser), { replace: true });
                }else if(data?.status_code === 403){
                    errorToast(data?.data?.message);
                }
                
                else if (data?.data?.status_code === 400) {
        errorToast(data?.data?.massage);
        // console.log(data?.data,"response1.........................")
        const code = data?.data?.status_code
     const otp_req= data?.data?.data?.otp_required
     const tokn = data?.data?.data?.session_token
    //  console.log(code,otp_req,tokn)
   if (code===400
  && tokn  && otp_req
)
   {
    // console.log(response,"response2.........................")
  const token = tokn
dispatch(validateUserSessionGetAsync(withSkipGlobalApiError({session_token:token})))
.then((response)=> {
  if(response.payload?.data?.is_valid){ navigate('/auth/mfa-login',{state:{sessionToken:token}});
  // setLoading(false);
  // setPendingLogin(values)

}else{errorToast(response.payload?.data?.massage)}})
    

      return
    }
      } 
      
      
                
                else{
                  if(data?.data?.status_code === 403){
                    errorToast(data?.data?.massage);
                  }else{
                    errorToast("Unable to Login")
                  }
                }
          } catch (error) {
            console.error("Error:", error);
          }
  };

  return (
    <div className="google-button-wrapper">
      <div id="google-login-btn" ref={googleButtonRef} />
    </div>
  );
};

export default GoogleLoginButton;
